<template>
<div class="chapter">
<div class="inner_page">
<a id="i524"></a><a id="i805"></a><a id="i840"></a><a id="i2163"></a><a id="i2177"></a><a id="VPS-5"></a>
<h2 class="part">BOOK I</h2>
<h2 class="ptitle">Isolated Incidents</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?47db95bb